import { Logger } from "react-logger-lib";
import { appInsights } from "../../applicationInsights";
import { baseContainer } from "../index";

var of = (module) => {
  const trackEvent = (type, name, properties) => {
    if (appInsights != null && baseContainer.getConfig()?.appInsights?.enable) {
      Logger.of(`${module}.AppInsights`).info(...properties);
      appInsights.trackEvent({
        name: name,
        properties,
      });
    }
  };
  return {
    info: (...args) => {
      trackEvent("INFO", module, args);
      Logger.of(module).info(...args);
    },
    warn: (...args) => {
      Logger.of(module).warn(...args);
    },
    error: (...args) => {
      trackEvent("ERROR", module, args);
      Logger.of(module).error(...args);
    },
    trace: (...args) => {
      Logger.of(module).trace(...args);
    },
  };
};

export default { of };
